import {useEffect, useState, useRef} from "react";
import { selectTreePc, navigationTreePC, cleanMeans } from '../actions/proyects.actions';
import {alpha, makeStyles, withStyles} from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import {useHistory} from "react-router-dom";
import subprojectIcon from '../assets/img/icons/subproject.png';
import projectIcon from '../assets/img/icons/project.png';

import {useSelector, useDispatch} from "react-redux";

function MinusSquare(props) {
	return (
		<div className="d-flex">
			<ion-icon name="chevron-down-outline"></ion-icon>
			<img src={projectIcon} alt="icons" width="15" style={{ marginRight: 8}} {...props}/>
		</div>
	);
}

function PlusSquare(props) {
	return (
		<div className="d-flex">
			<ion-icon name="chevron-forward-outline"></ion-icon>
			<img src={projectIcon} alt="icons" width="15" style={{ marginRight: 8}} {...props}/>
			
		</div>
	);
}

function CloseSquare(props) {
	return (
		<img src={subprojectIcon} width="15" alt="icons" style={{ marginRight: 8}} {...props}/>
	);
}

const StyledTreeItem = withStyles((theme) => ({
	iconContainer: {
		"& .close": {
			opacity: 0.3,
		},
	},
	group: {
		marginLeft: 7,
		paddingLeft: 18,
		borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
	},
}))((props) => <TreeItem {...props} />);

const useStyles = makeStyles({
	root: {
		height: 264,
		flexGrow: 1,
		maxWidth: 400,
	},
	menu: {
		position: 'fixed',

		fontSize: '14px',
		backgroundColor: '#fff',
		borderRadius: '2px',
		width: '150px',
		height: 'auto',
		padding: 0,
		margin: 0,
		listStyle: 'none',
		boxShadow: '0 0 20px 0 #ccc',
		opacity: 1,
		transition: 'opacity 0.5s linear',

	},
	menuItem: {
		cursor: 'pointer',
		padding: '0 10px ',
		"&:hover,&:focus": {
			// border: "2px solid red",
			color: 'white',
			backgroundColor: 'rgb(60, 141, 188)',
			'& .MuiOutlinedInput-notchedOutline': {
			  border: 'none'
			}
		  }
	}
});

const TreePcg = ({ nodeSelected, codCla, data, urlPrefix, onSelectItem }) => {
	
	const classes = useStyles();
	let history = useHistory();
	const proyects = useSelector((state) => state.proyects);
	const menuContexRef = useRef();
	const lastLevelRef = useRef();
	const dispatch = useDispatch();

	const [lastLevel, setLastLevel] = useState(5);
	const [loading, setLoading] = useState(false);
	const [refreshTree, setRefreshTree] = useState(null);
	const [treeData, setTreeData] = useState([]);
	const [search, setSearch] = useState();
	const [itemSelected, setItemSelected ] = useState('')
	const [searchRegex, setSearchRegex] = useState();
	const [contextMenu, setContextMenu] = useState();
	const [openItemMenu, setOpenItemMenu] = useState({});

	
	const converTreeArrayToMap = (treeArray, openOrCloseLevel = -1, openOrCloseOption = true) => {
		let orderedLevels = {};
		
		for (let i = 0; i < treeArray.length; i++) {
			const item = treeArray[i];
			// if (item.Nivel >= levelStart) {
				if (!orderedLevels[item.Nivel]) {
					orderedLevels[item.Nivel] = [];
				}
				// if (item.Nivel > lastLevel) {
				// 	setLastLevel(item.Nivel);
				// }
				// open all levels
				if ( (openOrCloseLevel > -1 && openOrCloseOption === true && item.Nivel <= openOrCloseLevel) || 
					// closed all levels
					(openOrCloseLevel > -1 && openOrCloseOption === false && item.Nivel === openOrCloseLevel) || 
					// select url id
					(openOrCloseLevel === -1 && nodeSelected && nodeSelected.startsWith(item.CodClasificacion))
				) {
					dispatch(selectTreePc(item.CodClasificacion, openOrCloseOption));
				}
				orderedLevels[item.Nivel].push({
					searchMatch: false,
					hidden: false,
					...item,
				});
			// }
		}
		return orderedLevels;

	}

	const orderAllElements = (level = 1, parent = null, treeMap = null) => {
		if( (!treeMap || !treeMap[level]) ) {
			
			return null;
		};
		const nextLevel = level + 1;
		return treeMap[level]
				.filter(
					(item) =>
						parent === null || item.PhantomParentId === parent.CodClasificacion
				)
				.map((filter) => {
					filter['breadcrumbs'] = level > 1 ? `${parent.breadcrumbs ? parent.breadcrumbs + ' / ' : '' }${filter.Descripcion}` : '';
					// filter['prevParents'] = parent ? [...parent.prevParents, filter.CodClasificacion] : [filter.CodClasificacion];
					filter.changeParent = parent 
						? () =>{ 
							filter.hidden = false;
							parent.changeParent();
							// TODO: aqui agregar para que se abra, en nuestro redux de selecteds
						} 
						: () => {
							filter.hidden = false;
						};
					if ( level === 1 || !search || search === '' ) {
						filter['hidden'] = false;
					} else {
						const descriptionLower = filter.Descripcion.toLowerCase();
						filter.searchMatch = new RegExp(search.toLowerCase()).test(descriptionLower) // descriptionLower.includes(search.toLowerCase());
						if (filter.searchMatch || (searchRegex !== '' && descriptionLower.match(searchRegex))) {
							
							filter.changeParent();
						} else if ( parent && parent.searchMatch ) {
							filter.hidden = false;
						} else {
							filter['hidden'] = true;
						}
					}
					filter['items'] = orderAllElements(nextLevel, filter, treeMap);
					return filter;
				});
	}

	const prepareTreeData = (openOrCloseLevel, openOrCloseOption) => {
		setLoading(true);
		if ( search && search.includes(' ') ) {
			const myRegex = `(?=.*${search.toLowerCase().replaceAll(' ', ')(?=.*')})`;
			setSearchRegex(new RegExp(myRegex));
			setSearchRegex(myRegex);
		} else {
			setSearchRegex('');	
		}
		const treeMap = converTreeArrayToMap( data, openOrCloseLevel, openOrCloseOption );
		const anyThing = orderAllElements(1, null, treeMap, openOrCloseLevel, openOrCloseOption);
		setTreeData(anyThing);
		setLoading(false);
	}

	useEffect(() => {
		prepareTreeData();
		// eslint-disable-next-line
	}, [data, search]);
	
		
	const changeItem = (itemClassification, newTitle) => {
		if (onSelectItem) onSelectItem(itemClassification);
		if (itemSelected === itemClassification.CodClasificacion) return;
		setItemSelected(itemClassification.CodClasificacion);
		dispatch(navigationTreePC(newTitle));
		return history.push(`${urlPrefix}${itemClassification.CodClasificacion}`);
	}

	const drawerItems2 = (level, items) => {
		if ( !items ) return '';
		if ( level > lastLevelRef.current ) {
			setLastLevel(level);
		}
		return items.map((item) => {
			if (level === lastLevel) {
				if (
					nodeSelected &&
					refreshTree === null &&
					nodeSelected ===
					item.CodClasificacion
				) {
					setRefreshTree(true);
					dispatch(
						navigationTreePC(
							`${item['breadcrumbs']}`
						)
					);
				}
				return (
					<StyledTreeItem  
						key={item.CodClasificacion}
						nodeId={item.CodClasificacion}
						label={item.Descripcion} 
						hidden={ item.hidden }
						className="seleted_tree"
						onLabelClick={( ) =>{ 
							// dispatch(cleanMeans());
							// dispatch(urlPc(`/projects/${item.CodClasificacion}`))
							// dispatch()
							changeItem(item, `${item.breadcrumbs}`)}
						}
					/>
				
				);
			} else {
				if (
					nodeSelected &&
					refreshTree === null &&
					nodeSelected ===
					item.CodClasificacion
				) {
					
					setRefreshTree(true);
					dispatch(
						navigationTreePC(
							`${item.breadcrumbs} / ${item.Descripcion}`
						)
					);
				}
				return (
					<StyledTreeItem
						key={`key-${item.CodClasificacion}.`}
						nodeId={item.CodClasificacion}
						label={item.Descripcion}
						hidden={ item.hidden }
						onIconClick={() => {
							// setRefreshTree([]);
							dispatch(selectTreePc(item.CodClasificacion));
						}}
						onLabelClick={ () => {
							changeItem(item, item['breadcrums'])
							dispatch(cleanMeans());
							dispatch(
								navigationTreePC(
									`${item.breadcrumbs}`
								)
							);
							// dispatch(urlPc(`/projects/${CodClasificacion}/${urlLabel}/${item.CodClasificacion}`))
						}}
						
					>
						{ drawerItems2(( level + 1 ), item.items)}
					</StyledTreeItem>
				);
			}
		});
	}

	const contexMenuHandle = (e) => {
		e.preventDefault();
		setContextMenu({
			xPos: `${e.pageX}px`,
			yPos: `${e.pageY}px`,
		});
	}

	useEffect(() => {
		menuContexRef.current = contextMenu;
	}, [contextMenu])
	useEffect(() => {
		lastLevelRef.current = lastLevel;
	}, [lastLevel])

	return (
		<>
			<div className="input-group mb-2">
				<div className="input-group-prepend">
					<div className="input-group-text" id="btnGroupAddon">
						<i className="fas fa-search"></i>
					</div>
				</div>
				<input
					type="search"
					className="form-control"
					placeholder="Buscador..."
					aria-label="Input group example"
					aria-describedby="btnGroupAddon"
					onChange={({target}) => setSearch(target.value)}
				/>
			</div>
			<div 
				onContextMenu={contexMenuHandle}
				onClick={(e) => {
					if (menuContexRef.current) {
						e.preventDefault();
						setContextMenu();
					}
				}}
			>
				<TreeView
					className={classes.root}
					// defaultExpanded={["1"]}
					defaultCollapseIcon={<MinusSquare />}
					defaultExpandIcon={<PlusSquare />}
					defaultEndIcon={<CloseSquare />}
					expanded={proyects.treeSelectedsPc}
					selected={nodeSelected}
					// className="mb-5"
				>
				
				{
					loading ? 'Cargando...' : 
					drawerItems2(1, treeData)
				}
				</TreeView>
			</div>
			{contextMenu && <ul
				className={classes.menu}
				style={{
					top: contextMenu.yPos,
					left: contextMenu.xPos,
				}}
				>
					{[...Array(3)].map((x, i) =>
						<li 
							key={i} 
							onClick={() => {
								let opened = openItemMenu;
								opened[i] = !openItemMenu[i] === true;
								prepareTreeData(i + 1, opened[i]);
								setOpenItemMenu(opened);
								setContextMenu();
							}} 
							className={classes.menuItem}
						>
							{openItemMenu[i] === true ? 'Cerrar' : 'Abrir'} niveles {i + 1}
						</li>
					)}
			</ul>}
		</>
	);
}

export default TreePcg
